import { gql } from '@apollo/client'

export const REQUESTED_INFO_TYPES_QUERY = gql`
  query requestedInfoTypes {
    requestedInfoTypes {
      collection {
        id
        name
        kind
        description
        createdAt
        updatedAt
        user {
          id
        }
      }
    }
  }
`
